import ProposalWizard from '@models/proposal-wizard';

const defaultState = {
    step: 1,
    selectedLocation: {},
    proposalWizard: {},
};

export default {
    namespaced: true,
    state: defaultState,
    mutations: {
        setStep(state, step) {
            state.step = step;
        },
        setWizard(state, wizard) {
            state.proposalWizard = wizard;
        },
        resetState(state) {
            Object.assign(state, defaultState);
        },
        setSelectedLocation(state, location) {
            state.selectedLocation = location;
        },
    },
    getters: {
        isStatic(state, getters, rootState) {
            return !!rootState.ProposalStore.proposal.customer_id;
        },
    },
    actions: {
        async reset({ commit }) {
            commit('resetState', defaultState);
        },
        async getWizard({ commit, rootState }) {
            const wizard = await ProposalWizard.for(rootState.ProposalStore.proposal).first();
            commit('setWizard', wizard);
        },
    },
};
